import React from 'react';
import './QuizContainer.scss';
import Quiz from './Quiz';
import QuizType2 from './QuizType2/QuizType2.js';
import QuizType3 from './QuizType3/QuizType3.js';
import QuizType4 from './QuizType4/QuizType4.js';
import Result from './Result/Result';
import { setOpenSendBox, onShadeView } from '../Contacts/contactsSlice';
import { getInitialState } from './quizSlice';
import { mesHrefSetForShare } from '../Messages/messageslice';
import { closeAllView, showView, closeQuizActive } from '../../Menu/MenuSide/menuSideSlice';
//import { closeQuizView } from './quizSlice';
import { setSelectedNoteId, setSelectedNoteName } from '../Notes/noteslice';
import { idNoteLoad } from '../../Admin/adminSlice';
import DataQuiz from './DataQuiz/DataQuiz';
import InputFormForWorkMistake from './InputFormForWorkMistake/InputFormForWorkMistake';
import { openInputFormForWorkMistake, openDataQuizView } from './quizSlice';
import { userAnswerRight, userAnswerWrong, nextQuestion, getResult } from './quizSlice.js';

const QuizContainer =(props) => {
    const { dispatch } = props;

//RETURN TO MENU OR TO FIRST VIEW
    const onClickEnd = () =>{
        const moduleData = props.moduleData;

        if (moduleData.length === 0 && props.previousModule === 2) {
           // dispatch(closeQuizView());
           // dispatch(openCategoryView());
           dispatch(getInitialState());
           dispatch(closeQuizActive());
           dispatch(closeAllView());
           dispatch(showView(1));
        } else {
           // dispatch(closeQuizView());
           // dispatch(showFirstContentView());
           dispatch(getInitialState());
           dispatch(closeQuizActive());
           dispatch(closeAllView());
           dispatch(showView(props.previousModule));
        }
       
    }
 //HANDLE SHARE  
 const handleClickShare = () => {
   
    dispatch(setOpenSendBox());
    dispatch(onShadeView());
    dispatch(mesHrefSetForShare("1"));

} 
 //HANDLE SHARE  
 const handleClickNote = () => {
     const selectedNoteId = props.quizRedux.quizId;
     const dataNotes = props.dataNotes; 

    const findNote = (dataNotes) => {
        const result = dataNotes.findIndex(item => item.id === selectedNoteId);
        return result;
    };
   
    const noteExist = findNote(dataNotes);

    if (noteExist === -1) {

        console.log('Load NEW notes');
        dispatch(closeAllView());
        dispatch(idNoteLoad(selectedNoteId));
        dispatch(setSelectedNoteId(selectedNoteId));
        dispatch(setSelectedNoteName(props.quizRedux.quizName));
        dispatch(showView(33)); 
    } else {
        dispatch(closeAllView());
        dispatch(setSelectedNoteId(selectedNoteId));
        dispatch(setSelectedNoteName(props.quizRedux.quizName));
        dispatch(showView(33));
    };


} 
 //HANDLE OPEN DATA VIEW
 const handledataQuizView = () => {
   
    dispatch(openDataQuizView());


} 

 //HANDLE MISTAKES QUIZ VIEW
 const handleMistkesView = () => {
   
    dispatch(openInputFormForWorkMistake());


} 





//SET NEW QUESTION
const setNextQuestion = (sortQuestion) => {
    console.log(sortQuestion);
  const { dispatch } = props;
  if (props.quizRedux.questionId < props.quizRedux.questionLength) {
    dispatch(nextQuestion(sortQuestion));
  } else {
       setTimeout (() => setResults (getResults ()), 300);
  }
 }


//HANDLER CLICK ANSWER
const setUserAnswer = (answer, idx) => {
  const { dispatch } = props;
  console.log(typeof(answer));
  console.log(answer);
  if (answer === '100') {
      dispatch(userAnswerRight({answer, idx}));
   } else {
    dispatch(userAnswerWrong(idx));
   }
}
//HANDLER ANSWER
const handleAnswerSelected = (idx, event) => {
    setUserAnswer(event.currentTarget.value,idx);
}

//HANDLER ANSWER FOR QUEST TYPE 2
const handleAnswerSelectedForQuestType2 = (idx, result) => {
   // console.log(idx);
   //  console.log(result);
    setUserAnswer(result, idx);
}

//HANDLER ANSWER FOR QUEST TYPE 3
const handleAnswerSelectedForQuestType3 = (idx, result) => {
   // console.log(idx);
   //  console.log(result);
    setUserAnswer(result, idx);
}

//RESULT
const getResults = () => {
  const result = true;
  return result;
   }
 const setResults = (result) => {
  const { dispatch } = props;
   dispatch(getResult(result));
     }



//RENDER HEADER

const renderHeader = () => {
    
    return (    
            <div className="main">
                    <div className="return-menu">
                       <button className="exit" onClick={onClickEnd}></button>
                    </div>
                    
                    <div className="services">
                        
                        <button className="note" onClick={handleClickNote}></button>
                        <button className="data-quiz" onClick={handledataQuizView}></button>
                         <button className="mistakes-quiz" onClick={handleMistkesView} 
                         disabled={props.quizRedux.result ? true : false}></button>
                        {(props.authData.modulesName[1].status || (props.authData.userRole[0].role_id === 1)) ?<button className="troubles"></button> : null}
                        {(props.authData.modulesName[2].status || (props.authData.userRole[0].role_id === 1)) ?<button className="share" onClick={handleClickShare}></button> :null}
                    </div>
                    
                    <p className="title">{props.quizRedux.quizId}.{props.quizRedux.quizName}</p>
             </div>
)
             
}
//RENDER CLOSE VIEW
const renderClose = () => {
    
    return (    
            <div className="main">
                    <div className="return-menu">
                       <button className="exit" onClick={onClickEnd}></button>
                       <span> Тесты еще не созданы.</span>
                    </div>
                    
                   
             </div>
)
             
}
//RENDER QUIZ
const renderQuiz = () => {
  
    const quizDataType = props.quizRedux.sortQuestion;
   
    console.log('TYPE ' + quizDataType);

    if (quizDataType === 2) {
        return (
            <QuizType2 
            quizRedux={props.quizRedux}
            nextQuestion={setNextQuestion}
            onAnswerSelected={handleAnswerSelectedForQuestType2}
            styleAnswer={props.quizRedux.styleAnswer}
            isSelected={props.quizRedux.selectedItem}
            dispatch={dispatch}

            />
        ); 
    } 
    if (quizDataType === 3) {
        return (
            <QuizType3 
            quizRedux={props.quizRedux}
            dispatch={dispatch}
            nextQuestion={setNextQuestion}
            onAnswerSelected={handleAnswerSelectedForQuestType3}
            styleAnswer={props.quizRedux.styleAnswer}
            isSelected={props.quizRedux.selectedItem}
            sortQuestion={quizDataType}
            />
        ); 
    }
    if (quizDataType === 4) {
        return (
            <QuizType4 
            quizRedux={props.quizRedux}
            dispatch={dispatch}
            nextQuestion={setNextQuestion}
            onAnswerSelected={handleAnswerSelectedForQuestType2}
            styleAnswer={props.quizRedux.styleAnswer}
            isSelected={props.quizRedux.selectedItem}
            />
        ); 
    }  

    if (quizDataType === 1) {
        return (
            <Quiz 
            quizRedux={props.quizRedux}

            onAnswerSelected={handleAnswerSelected}
            nextQuestion={setNextQuestion}
            authData = {props.authData}
            />
        ); 

    }

  
}    
//RENDER RESULT
 const renderResult = () => {
     const { dispatch } = props;
     return (
         <Result 
         quizResult={props.quizRedux.result} 
         trueAnswer={props.quizRedux.answersCount.trueAnswer}
         questionTotal={props.quizRedux.questionLength}
         quizRedux={props.quizRedux}
         userId={props.userId}
         dispatch={dispatch}
         finishedQuizes={props.finishedQuizes}
         previousModule ={props.previousModule}
         />
     )
 }
 //RENDER DATA QUIZ VIEW
 const renderDataQuizView = () => {
     const { dispatch } = props;
     return (
         <DataQuiz 
         dataQuiz={props.quizRedux.dataQuiz}
         dispatch={dispatch}
        
         />
     )
 }
  //RENDER DATA QUIZ VIEW
 const renderInputFormForWorkOnMistake = () => {
     const { dispatch } = props;
     return (
         <InputFormForWorkMistake
         finishedQuizes={props.authData.finishedQuizes}
         quizRedux={props.quizRedux}
         mistakesOptionQuiz={props.quizRedux.mistakesOptionQuiz}
         dispatch={dispatch}
        
         />
     )
 }
//RENDER ALL   





    if (props.quizRedux.quizView) {
        return (
            <div className="QuizContainer">
                {((props.quizRedux.dataQuiz.length !== 0) || (props.quizRedux.initialDataForQuizType2.length !== 0)  || (props.quizRedux.initialDataForQuizType3.length !== 0) || (props.quizRedux.initialDataForQuizType4.length !== 0)) ? renderHeader() : renderClose()}
                {props.quizRedux.result ? renderResult() : renderQuiz()}
                {props.quizRedux.dataQuizView ? renderDataQuizView() : null }
                {props.quizRedux.inputFormForWorkMistakeView ? renderInputFormForWorkOnMistake() : null }
            </div>
        )
    } else return null;





}
export default QuizContainer;